import { Component } from "preact";

import style from "./index.scss";

import polyfillSettingsUpdater from '../../lib/polyfill-settings-updater'

export default class Browser extends Component {

  state =  {
    iframe: null,
    loaded: false
  }

  componentDidMount() {
    let iframe =  this.base.querySelector('iframe')
    this.setState({ iframe })
  }
  
  onSubmit = (evt) => {
    evt.preventDefault();
    let url = this.base.querySelector("#url").value;
    this.props.updateDeviceSettings({ url })
  }

  oniframeLoad = () => {
    this.setState({ loaded: true })
    let { orientation, deviceType, windowMode, url } = this.props
    // ugly and can cause bugs, but oh well
    if ( !url || url.trim() === '' ) return
    let settings = polyfillSettingsUpdater( { orientation, deviceType, windowMode } )
    
    let iframe = this.state.iframe || this.base.querySelector('iframe');
    iframe.contentWindow.postMessage({ action: 'update', value: settings }, url)
  }

  componentWillReceiveProps(np) {
    let { orientation, deviceType, windowMode, url } = np
    if( url !== this.props.url ) {
      this.setState({ loaded: false })
      return
    }
    if( this.state.loaded === false) return
    let settings = polyfillSettingsUpdater( { orientation, deviceType, windowMode } )
    // ugly and can cause bugs, but oh well
    if ( !url || url.trim() === '' ) return

    let iframe = this.state.iframe || this.base.querySelector('iframe');
    iframe.contentWindow.postMessage({ action: 'update', value: settings }, url)
  }

  render(props) {
    return(
      <div class={style.browser}>
        <div class={style.addressBar}>
          <form onSubmit={this.onSubmit}>
            <input type="text" id="url" class={style.url} value={props.url} required />
          </form>
        </div>
        <iframe class={style.contentFrame} src={props.url} onload={this.oniframeLoad}/>
      </div>
    )
  }
}